/**
 * Fragrance Quiz Analytics — Phase 7
 * Sends events via gtag() only (same pattern as assets/quiz-analytics.js). No GTM.
 * Section setting analytics_mode: 'gtag' = on, anything else = no-op.
 *
 * Primary metrics (funnel + behavior + outcome):
 * 1. fragrance_quiz_step_view — step number viewed (funnel drop-off by step).
 * 2. fragrance_quiz_answer_select — question_id + answer_id (A/B/C/D distribution per question).
 * 3. fragrance_quiz_result_view / fragrance_quiz_complete — result_scent (which scent people get matched with).
 */
(function () {
  'use strict';

  var QUIZ_ID = 'athena_fragrance_quiz_v1';

  function isGtagEnabled() {
    var configEl = document.getElementById('fq-config');
    if (!configEl) return false;
    var mode = (configEl.getAttribute('data-analytics-mode') || '').toLowerCase();
    return mode === 'gtag';
  }

  /**
   * track(eventName, params)
   * - Only sends when analytics_mode is 'gtag'. Always uses gtag('event', eventName, payload).
   * - Merges in quiz_id; caller passes rid, step, and event-specific params.
   * - No-op if mode is not 'gtag' or gtag is not available (avoids throwing).
   */
  function track(eventName, params) {
    if (!isGtagEnabled() || typeof window.gtag !== 'function') return;

    var payload = Object.assign(
      {},
      { quiz_id: QUIZ_ID },
      typeof params === 'object' && params !== null ? params : {}
    );

    try {
      window.gtag('event', eventName, payload);
    } catch (e) {
      // No-op on error so quiz behavior is unaffected
    }
  }

  window.FragranceQuizAnalytics = { track: track };
})();
